import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { APP_CONFIG } from './constants/app';
import { chargerLaMarque } from './services/marque';

// [C2 — marque blanche] La marque est posée AVANT le premier rendu : sinon
// l'écran s'affiche aux couleurs maison puis bascule à celles du cabinet, et ce
// clignotement est exactement ce qui trahit une marque blanche rapportée après
// coup. L'attente est bornée : si l'API ne répond pas, on rend quand même.
void chargerLaMarque(APP_CONFIG.api.baseUrl);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
